/**
 * Domain API facade ($API on globalProperties).
 * Domain modules live in sibling files; transport in @/http.
 */
import { setAuthLogout, setEnsureSelectedGroup } from '../http/request'
import { getAbortController, resetAbortController } from '../http/session'

import { auth } from './auth'
import { storage } from './storage'
import { legalPerson, medicalRecord, legalPersonParent } from './legalPerson'
import { file } from './file'
import { user } from './user'
import { group, groupMember, subGroup, subGroupMember } from './group'
import { bank, cashFlowCategory, cashier, cashierTransfer, cashierMovement, invoice, billingAgreement, paymentMethod, groupPayment, receipt } from './finance'
import { checkout } from './checkout'
import { botConversa } from './messaging'
import { pdf, excel } from './exports'
import { event, eventInvitation, eventStaff, eventFile, eventAuthorization } from './events'
import { news, newsReceiver, newsAttachment } from './news'
import {
  store,
  productCategory,
  product,
  productVariant,
  storeProduct,
  stock,
  storeUser,
  sale,
  ticket,
} from './stores'
import { lgpd } from './lgpd'
import { promoBanner } from './promoBanner'
import { ticketOffer } from './ticketOffer'

setAuthLogout(() => auth.logout())
setEnsureSelectedGroup(() => storage.selectedGroup())

const api = {
  get abortController() {
    return getAbortController()
  },
  /** Abort in-flight requests and issue a fresh signal (required before a new call after abort). */
  resetAbortController,
  auth,
  storage,
  legalPerson,
  legalPersonParent,
  file,
  medicalRecord,
  user,
  group,
  groupMember,
  subGroup,
  subGroupMember,
  bank,
  cashFlowCategory,
  cashier,
  cashierTransfer,
  cashierMovement,
  invoice,
  checkout,
  billingAgreement,
  paymentMethod,
  botConversa,
  pdf,
  excel,
  receipt,
  groupPayment,
  event,
  eventInvitation,
  eventStaff,
  eventFile,
  eventAuthorization,
  news,
  newsReceiver,
  newsAttachment,
  store,
  productCategory,
  product,
  productVariant,
  storeProduct,
  stock,
  storeUser,
  sale,
  ticket,
  lgpd,
  promoBanner,
  ticketOffer,
}

export default api
